module.exports = __webpack_public_path__ + "img/addresses.5fab7359.svg";